// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "em-pthread" + "." + "662346cf" + ".chunk.js";
};